<template>
    <div class="NodeEditor">
        <NodeSaveStatus></NodeSaveStatus>
        <!--Header Editor-->
        <NodeHeaderEditor
            key="NodeHeaderEditor"
            :name.sync="node.name"
            :id="node.id"
            :slug="node.slug"
            :type="node.type"
            :is-fallback="true"
            ref="NodeHeaderEditor"
            @save="saveNode"
            @delete="deleteNode"
            @close="closePanelRight"
        ></NodeHeaderEditor>
        <!--Content Editor-->
        <v-tabs slider-color="#FFFFFF" v-model="currentTab" v-if="node.config.cardList.length > 0">
            <v-tab :href="`#tab-note`">{{ $f.tc('note') }}</v-tab>
            <v-tab :href="`#tab-action`">{{ $t('action') | capitalize }}</v-tab>
            <v-tabs-items touchless v-model="currentTab">
                <v-tab-item :value="`tab-note`">
                    <div class="scroll-container fci-scrollbar">
                        <ScenarioCard name="Note">
                            {{ $f.tc('fallbackNote') }}
                        </ScenarioCard>
                    </div>
                </v-tab-item>
                <v-tab-item :value="`tab-action`">
                    <div class="scroll-container fci-scrollbar">
                        <ScenarioCard
                            v-for="(card, cardIndex) in node.config.cardList"
                            :key="cardIndex"
                            :name.sync="card.name"
                            @delete="deleteCard(cardIndex)"
                            @moveUp="moveCardUp(cardIndex)"
                            @moveDown="moveCardDown(cardIndex)"
                            @updateCardName="newName => updateCardName(newName, cardIndex)"
                            :delete-able="isEdit"
                            :move-able="isEdit"
                            :name-editable="isEdit"
                            :name-invalid="['init', 'end']"
                        >
                            <ApiEditor
                                v-if="card.type === CardType.API"
                                :item.sync="card.data"
                                ref="card"
                                @save="shouldSave ? saveNode() : null"
                                :editable="isEdit"
                            ></ApiEditor>
                            <ApiParameterEditor
                                v-if="card.type === CardType.SET_USER_ATTRIBUTE"
                                :items.sync="card.data"
                                ref="card"
                                @save="shouldSave ? saveNode() : null"
                                :editable="isEdit"
                            ></ApiParameterEditor>
                            <LuaEditor
                                v-if="card.type === CardType.LUA"
                                :item.sync="card.data"
                                @save="shouldSave ? saveNode() : null"
                                :editable="isEdit"
                                ref="card"
                            ></LuaEditor>
                        </ScenarioCard>
                    </div>
                </v-tab-item>
            </v-tabs-items>
        </v-tabs>
        <div v-else class="p-12 pt-0 fci-scrollbar condition-scroll">
            <ScenarioCard name="Note">
                {{ $f.tc('fallbackNote') }}
            </ScenarioCard>
        </div>
        <!--Footer Editor-->
        <NodeFooterEditor
            :actions-not-use="[NodeEditorMenuCode.ADD_SETTING, , NodeEditorMenuCode.ADD_NLP_CONFIG]"
            @menuSelect="onMenuSelect($event)"
        ></NodeFooterEditor>
    </div>
</template>

<script>
import NodeEditor from "@/views/Scenario/NodeEditor/NodeEditor";
import NodeSaveStatus from "@/views/Scenario/NodeEditor/NodeSaveStatus";
import ScenarioCard from "@/views/Scenario/components/ScenarioCard";
import ApiEditor from "@/views/Scenario/NodeEditor/common/ApiEditor";
import ApiParameterEditor from "@/views/Scenario/NodeEditor/common/ApiParameterEditor";
import NodeFooterEditor from "@/views/Scenario/NodeEditor/common/NodeFooterEditor";
import NodeHeaderEditor from "@/views/Scenario/NodeEditor/common/NodeHeaderEditor";
import LuaEditor from "@/views/Scenario/NodeEditor/common/LuaEditor";
import ScenarioService from "@/services/scenario.service";

const {NodeEditorMenuCode} = ScenarioService
export default {
    name: "FallbackNodeEditor",
    extends: NodeEditor,
    components: {
        LuaEditor,
        ScenarioCard,
        ApiEditor,
        ApiParameterEditor,
        NodeSaveStatus,
        NodeFooterEditor,
        NodeHeaderEditor
    },
    data() {
        return {
            NodeEditorMenuCode
        }
    }
}
</script>

<style scoped lang="scss">
@import "NodeEditor.scss";

.condition-scroll {
    height: calc(100% - 49px);
    overflow-y: auto;
    padding-bottom: 52px;
}
</style>
